import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private refreshCompaniesSubject = new Subject<void>();

  // 🔁 Observable para ouvir no app-company-selector
  refreshCompanies$ = this.refreshCompaniesSubject.asObservable();

  // ✅ Função para emitir evento
  triggerRefreshCompanies() {
    this.refreshCompaniesSubject.next();
  }
}
